export default "__VITE_ASSET__BE1SS1Ky__"